<svelte:options accessors />

<script lang="ts">
  import IconClose from '@/comps-sdk/components/icon/close.svelte';
  import Popup from '@/comps-sdk/components/popup';
  import { getActivityConfig } from '@/comps-sdk/modules/act-utils';

  import ActionBtn from './action-btn.svelte';

  export let modId: number;
  export let popTitle = '我的奖品';
  export let closeButton = true;
  export let maskClose = true;
  export let scene = 'iwan';

  export const list: any[] = [];
  export let isShow = false;

  let activityConfig: any = null;

  const handleCloseDrawer = () => {
    isShow = false;
  };

  getActivityConfig().then((res) => {
    activityConfig = res;
  });
</script>

<Popup
  bind:value={isShow}
  position="bottom"
  round
  get-container="body"
  class="lottery-award-list-popup"
  close-on-click-overlay={maskClose}
>
  <div class="title">
    {popTitle}
    {#if closeButton}
      <IconClose class="close-icon" on:click={handleCloseDrawer} />
    {/if}
  </div>
  {#if list.length > 0}
    <div class="content-wrapper">
      {#each list as item}
        <div class="item">
          <div class="left-item">
            <div class="item-name">
              {item.instance_info.name}
            </div>
            <div class="item-time">
              {item.order_detail ? new Date(item.order_detail.order_ts).toLocaleString() : ''}
            </div>
          </div>
          <ActionBtn
            class="right-item"
            {modId}
            lotteryInfo={item}
            {activityConfig}
            {scene}
            on:close-drawer={handleCloseDrawer}
          />
        </div>
      {/each}
    </div>
  {:else}
    <div class="empty-wrapper">您还未获取到任何奖品</div>
  {/if}
</Popup>

<style lang="scss">
  :global(.lottery-award-list-popup) {
    padding: 16px 0px;
    min-height: 35vh;
    max-height: 70vh;
    display: flex;
    flex-direction: column;

    .title {
      font-size: 20px;
      text-align: center;
      padding: 6px 0px;
      font-weight: bold;
      position: relative;
      :global(.close-icon) {
        position: absolute;
        top: 0px;
        right: 20px;
      }
    }

    .content-wrapper {
      padding-bottom: 20px;
      flex: 1;
      overflow-y: scroll;
    }

    .item {
      display: flex;
      justify-content: space-between;
      justify-items: center;
      padding: 16px 0px;
      margin: 0px 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .left-item {
        .item-name {
          font-size: 16px;
        }
        .item-time {
          font-size: 14px;
          margin-top: 10px;
        }
      }
      :global(.right-item) {
        display: inline-block;
        margin-top: 4px;
      }
    }

    .empty-wrapper {
      flex: 1;
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 1px;
    }
  }
</style>
